<div
  class="content"
  [style.backgroundColor]="
    match?.matchStatus === 'COMPLETED' && setWinner
      ? 'rgba(255, 128, 139, 0.1)'
      : null
  "
>
  <div data-testid="participant-name" class="team-content {{themeService?.isDarkMode ? 'dark': 'light'}}">
    @if(profileImage) {
    <ion-avatar slot="start">
      <img style="width: auto" [src]="profileImage" />
    </ion-avatar>
    } @else if(teamLogo) {
    <ion-thumbnail slot="start">
      <img style="width: auto" [src]="teamLogo" />
    </ion-thumbnail>
    } @else if(teamName) {
    <span class="team-name" [ngStyle]="{ backgroundColor: sideColor }"
      >{{ teamName?.slice(0, 1) }}
    </span>
    }

    @if(!summaryView){
        <div class="player-name">
            <span [ngStyle]="match?.matchStatus !== 'COMPLETED' ? getServerStyle(1) : ''">{{ getParticipantName(1) }}</span>
            @if (match.matchType === 'D') {
            <br />
            <span [ngStyle]="match?.matchStatus !== 'COMPLETED' ? getServerStyle(2) : ''">{{ getParticipantName(2) }}</span>
            }
          </div>
    }
  </div>
</div>
